/**
 * Side panel configuration constants
 */

// Panel width in pixels
export const PANEL_WIDTH = 375;

// Gap between stacked panels
export const PANEL_GAP = 5;

// Maximum number of panels that can be open simultaneously
export const MAX_OPEN_PANELS = 2;

// Animation duration for panel transitions (ms)
export const PANEL_ANIMATION_DURATION = 200;

/**
 * Core panel IDs for built-in panels
 */
export const CORE_PANEL_IDS = {
    VIEWS_MARKUPS: "viewsMarkups",
    ALL_ITEMS: "allItems",
    OBJECTS: "objects",
    PROPERTIES: "properties",
    GROUPS: "groups",
    DEVIATIONS: "deviations",
    SETTINGS: "settings",
    DIMENSION: "dimension",
} as const;

export type CorePanelId = (typeof CORE_PANEL_IDS)[keyof typeof CORE_PANEL_IDS];
